<template>
  <header>
    <div class="header_con">
     
      <router-link to='/'><img src="https://kx-gw.oss-cn-beijing.aliyuncs.com/logo.png" class="logo"/></router-link>
      <ul class="headerTab">
        <router-link tag="li" active-class="alive" to="/" exact>首页</router-link>
        <router-link tag="li" active-class="alive" to='aboutUs' exact>关于我们</router-link>
        <li>
          <div  :class="this.$route.name == 'shortVideoMarketing' || this.$route.name == 'whLiveBroadcast' ? 'alive' : ''" class="title">业务介绍</div>
          <div class="item">
            <router-link tag="div" to="shortVideoMarketing" exact>短视频营销</router-link>
            <!-- <router-link tag="div" to="whLiveBroadcast" exact>网红直播</router-link> -->
          </div>
        </li>
        <router-link tag="li" active-class="alive" to="businessCooperation" exact>业务合作</router-link>
        <!-- <li @click="goBigData">问星数据</li> -->
      </ul>
    </div>
    <div class="moveHeader">
      <ul>
        <router-link tag="li" active-class="activeMove" to="/" exact>首页</router-link>
        <router-link tag="li" active-class="activeMove" to='aboutUs' exact>关于我们</router-link>
        <li>
          <div class="title"  @click="moveTabEvent(3)" :class="this.$route.name == 'shortVideoMarketing' || this.$route.name == 'whLiveBroadcast' ? 'activeMove' : ''">业务介绍</div>
          <div class="item" v-show="moveTab==3">
            <router-link tag="div" :to="{path: 'shortVideoMarketing'}" exact>短视频营销</router-link>
            <!-- <router-link tag="div" :to="{path: 'whLiveBroadcast'}" exact>网红直播</router-link> -->
          </div>
        </li>
        <router-link tag="li" active-class="activeMove" to="businessCooperation" exact>业务合作</router-link>
      </ul>
    </div>
  </header>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'head_pc',
  data () {
    return {
      moveTab:1,//0清空 3业务介绍  主要在主标题有副标题的时候使用
      pcTab:1,//1首页 2关于我们 3业务介绍  4业务合作
    }
  },
  mounted(){
    this.hoverTabPC();
    this.moveTab = 0;
    var _this = this;
    $(window).scroll(function(e){  
        _this.moveTab = 0;
    });  
    if(this.$route.path == '/whLiveBroadcast' || this.$route.path == '/shortVideoMarketing'){
      this.pcTab = 3;
    }else if(this.$route.path == '/'){
      this.pcTab = 1;
    }else if(this.$route.path == '/aboutUs'){
      this.pcTab = 2;
    }else if(this.$route.path == '/businessCooperation'){
      this.pcTab = 4;
    }
  },
  watch:{
    $route(to,from){
        this.moveTab = 0;
       $(window).scrollTop(0);

       if(this.$route.path == '/whLiveBroadcast' || this.$route.path == '/shortVideoMarketing'){
        this.pcTab = 3;
      }else if(this.$route.path == '/'){
        this.pcTab = 1;
      }else if(this.$route.path == '/aboutUs'){
        this.pcTab = 2;
      }else if(this.$route.path == '/businessCooperation'){
        this.pcTab = 4;
      }
    }
  },
  methods:{
    // goBigData(){
    //   window.open('https://www.wenxingshuju.com','_blank')
    // },
    hoverTabPC(){
      var _this = this;
      //划过tab时
      $(".headerTab li").hover(function () {
        $(".headerTab li").removeClass('alive');
        $(".headerTab li .title").removeClass('alive');
        $(".headerTab li").find('.item').css('display','none')
        $(this).find('.item').css('display','block')
        if($(this).find('.item').length == 0){
          $(this).addClass('alive')
        }else{
          $(".headerTab li .title").addClass('alive');
        }
      },function () {
        $(".headerTab li").find('.item').css('display','none')
        $(".headerTab li").removeClass('alive');
        $(".headerTab li .title").removeClass('alive');

        if($(".headerTab li").eq(_this.pcTab - 1).find('.item').length == 0){
          //此tab没有二级目录
          $(".headerTab li").eq(_this.pcTab - 1).addClass('alive');          
        }else{
          $(".headerTab li").eq(_this.pcTab - 1).find('.title').addClass('alive');          
        }
      })
    },
    moveTabEvent(tab){
      this.moveTab = tab;
    }
  }
}
</script>

<style scoped lang="scss">
  header .header_con ul::after{
    clear: both;
    content: " ";
    display: block;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
  .activeMove{
    color: red;
  }
  header{
    width: 100%;height: 0.9rem;background: #2d2d2d;color:#eeeeee;font-size: 0.16rem;line-height: 0.22rem;
    box-sizing: border-box;
    .header_con{
      width: 11.4rem;
      max-width: 11.40rem;height: 100%;margin: auto;position: relative;
      a{
        display: block;
        height: 85%;
        position: absolute;
        top: 0;bottom: 0;left: 0;
        margin: auto;
        .logo{
          height: 100%;
        }
      }
      ul{
        height: 0.46rem;
        position: absolute;
        top: 0;bottom: 0;right: 0;
        margin: auto;
        li{
          float: left;
          width: 1.46rem;
          line-height: 0.46rem;
          text-align: center;
          font-weight: bold;
          position: relative;
          z-index: 3;
          cursor: pointer;
          .item{
            background: #2D2D2D;
            margin-top: 0.27rem;
            line-height: 0.46rem;
            color: #ffffff;
            width: 100%;
            font-size:0.16rem;
            z-index: 3;
            position: relative;
            padding: 0.1rem 0;
            display: none;
            cursor: pointer;
            div{
              &:hover{
                color: #ff4400;
              }
            }
          }
          
        }
        .alive{
          height: 0.46rem;
          background: #EEEEEE;
          color: #222222;
          cursor: pointer;
        }
      }
    }
  }


  .moveHeader{
    display: none;
    position: fixed;
    bottom: 0;left: 0;
    width: 100vw;
    height: 0.5rem;
    line-height: 0.5rem;
    color: #333;
    background: #ffffff;
    border-top: 0.01rem solid #ddd;
    box-shadow: 0 0 0.06rem rgba(0,0,0,.1);
    z-index: 2;
    font-size: 0.14rem;
    ul{
      display: flex;align-items: center;justify-content: space-around;
      width: 100%;height: 100%;
      li{
        position: relative;
        width: 25%;
        text-align: center;
        .item{
            background: #2D2D2D;
            line-height: 0.45rem;
            color: #ffffff;
            width: 100%;
            z-index: 3;
            position: absolute;
            padding: 0.1rem 0;
            // display: none;
            top: -1.1rem;
            box-shadow: 0 0 0.06rem rgba(0,0,0,.1);            
        }
      }
    }
  }
  @media screen and (max-width: 640px) {
    header{
      width: 100%;
    }
    header .header_con .logo{
      height: 80%;
    }
    .headerTab{
      display: none;
    }
    .moveHeader{
      display: block;
    }
    header{
      height: 0.6rem;
      padding: 0 0.1rem;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/pc/public/Head.vue